import { Grid, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { noop } from 'shell/utils/noop';
import { IdentificationDocument } from 'shell/view-models/personal-data';

interface ItalianComponentProps {
  disabled?: boolean;
  values?: IdentificationDocument;
  errors?: FormikErrors<IdentificationDocument>;
  touched?: FormikTouched<IdentificationDocument>;
  onChange: (
    key: keyof IdentificationDocument,
    value: IdentificationDocument[keyof IdentificationDocument]
  ) => void;
}

const ItalianComponent = ({
  disabled,
  onChange,
  values,
  touched,
  errors,
}: ItalianComponentProps): React.ReactElement => {
  const handleMunicipalityListChange = useEventCallback(
    (municipality: MunicipalityAnprVM | null) => {
      onChange('municipality', municipality);
    }
  );

  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12} md={6}>
        <MunicipalityList
          label="Comune *"
          aria-label="Comune"
          value={values?.municipality || null}
          onChange={handleMunicipalityListChange}
          disabled={disabled}
          error={
            (touched?.municipality as FormikTouched<MunicipalityAnprVM>) &&
            Boolean(errors?.municipality as FormikErrors<MunicipalityAnprVM>)
          }
          fromDate={values?.issuedDate || null}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia"
          label="Provincia *"
          id="province"
          name="province"
          fullWidth
          disabled
          type="text"
          variant="outlined"
          value={values?.municipality?.province || ''}
          onChange={noop}
        />
      </Grid>
    </Grid>
  );
};

ItalianComponent.displayName = 'Italian component';

const Italian = memo(ItalianComponent);

export default Italian;
